import { Button, IconButton, ThemeProvider, Box } from "@mui/material";
import { theme } from "./theme";
import { Route, Routes } from "react-router-dom";
import Landing from "./pages/landing";
import AroundUs from "./pages/around-us";
import Contact from "./pages/contact";
import AboutUs from "./pages/about-us";
import Villas from "./pages/villas";
import VillasList from "./pages/villas-list";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Lenis from "lenis";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 700, // Animation duration (in ms)
      easing: "ease-in-out", // Easing style
      once: true, // Animation will happen only once
    });

    // // Initialize Lenis smooth scroll
    // const lenisInstance = new Lenis({
    //   lerp: 0.1,
    //   wheelMultiplier: 0.7,
    //   gestureOrientation: "vertical",
    //   normalizeWheel: false,
    //   smoothTouch: false,
    // });

    // setLenis(lenisInstance);

    // // Lenis animation frame
    // function raf(time) {
    //   lenisInstance.raf(time);
    //   requestAnimationFrame(raf);
    // }
    // requestAnimationFrame(raf);

    // // Cleanup function
    // return () => {
    //   lenisInstance.destroy();
    // };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <ScrollToTop lenis={lenis} />
        <Routes>
          <Route index element={<Landing />} />
          <Route path="around-us" element={<AroundUs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="villas" element={<VillasList />} />
          <Route path="villas/:slug" element={<Villas />} />
        </Routes>
        <a
          href="https://wa.me/918308173010?text=Hi,%20I%20have%20an%20enquiry"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            startIcon={
              <img src={"/images/about-us/whatsapp.svg"} height={32} alt="" />
            }
            height
            variant="contained"
            color="white"
            sx={{
              position: "fixed",
              bottom: 24,
              right: 48,
              px: 4,
              py: 3,
              zIndex: 99999,
              display: { xs: "none", md: "flex" },
            }}
          >
            Chat on Whatsapp
          </Button>
          <IconButton
            sx={{
              position: "fixed",
              bottom: 16,
              right: 16,
              px: 2,
              py: 2,
              zIndex: 99999,
              bgcolor: "white.main",
              "&:hover": {
                background: "white",
              },
              display: { xs: "flex", md: "none" },
            }}
          >
            <img src={"/images/about-us/whatsapp.svg"} alt="" />
          </IconButton>
        </a>
      </Box>
    </ThemeProvider>
  );
}

export default App;
